import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const ProfileHeader = ({ userRole, profileData, onEditPhoto }) => {
  const roleConfig = {
    superadmin: {
      label: 'Super Administrator',
      icon: 'Shield',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    client: {
      label: 'Opdrachtgever',
      icon: 'Building2',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    contractor: {
      label: 'Installateur',
      icon: 'Wrench',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    affiliate: {
      label: 'Affiliate Partner',
      icon: 'Users',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  };

  const currentRole = roleConfig?.[userRole] || roleConfig?.contractor;

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 lg:p-8 mb-6">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
        <div className="relative group">
          <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-full overflow-hidden border-4 border-border">
            <Image
              src={profileData?.avatar}
              alt={profileData?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <button
            onClick={onEditPhoto}
            className="absolute bottom-0 right-0 w-8 h-8 md:w-10 md:h-10 bg-primary text-primary-foreground rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-smooth elevation-md"
            aria-label="Profielfoto wijzigen"
          >
            <Icon name="Camera" size={16} />
          </button>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-2">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground truncate">
              {profileData?.name}
            </h1>
            <div className={`inline-flex items-center gap-2 px-3 py-1 ${currentRole?.bgColor} rounded-full w-fit`}>
              <Icon name={currentRole?.icon} size={16} color={`var(--color-${userRole === 'superadmin' ? 'error' : userRole === 'client' ? 'primary' : userRole === 'contractor' ? 'accent' : 'success'})`} />
              <span className={`caption font-medium ${currentRole?.color}`}>
                {currentRole?.label}
              </span>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3 md:gap-4 text-sm md:text-base text-muted-foreground mb-3">
            <div className="flex items-center gap-2">
              <Icon name="Mail" size={16} />
              <span className="truncate">{profileData?.email}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Phone" size={16} />
              <span>{profileData?.phone}</span>
            </div>
            {profileData?.location && (
              <div className="flex items-center gap-2">
                <Icon name="MapPin" size={16} />
                <span>{profileData?.location}</span>
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
              <div
                className="h-full bg-success transition-smooth"
                style={{ width: `${profileData?.completeness}%` }}
              />
            </div>
            <span className="caption text-muted-foreground whitespace-nowrap">
              {profileData?.completeness}% compleet
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;